import { render, staticRenderFns } from "./CircleTickIcon.vue?vue&type=template&id=6aba64d8&"
import script from "./CircleTickIcon.vue?vue&type=script&lang=js&"
export * from "./CircleTickIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports